

// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class AccountingSystemAccountsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'accounting-system-accounts';
        this.Server =
            this.props.context.getState().server.accountingSystemAccounts;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['publicAddress'];

        const defaultHead = [
            {
                id: 'cryptoTokenId',
                label: 'cryptoToken',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'cryptoTokens',
                object: 'cryptoToken',
                show: 'name'
            },
            {
                id: 'currencyId',
                label: 'currency',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'currencies',
                object: 'currency',
                show: 'name'
            },
            {
                id: 'publicAddress',
                label: 'publicAddress',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                displayGrid: false,
                displayDialogDetails: true,
                disableEditor: true,
                from: 'users',
                object: 'modifiedBy',
                show: 'email'
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: false,
                displayDialogDetails: true,
                disableEditor: true
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                displayDialogDetails: true,
                details: 'Json',
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}

